export const SUP_CONTACT_US_LOADER = {
  desktop: `
<div class="cui cui-grid">
  <div class="cui-container display-none display-lg-block">
    <div class="cui-row">
      <div class="cui-col-lg-12">
        <div class="cui-skeleton-paragraph -spacing--bottom-64 -spacing--top-40">
          <div class="cui-skeleton-paragraph__content" style="width: 260px">
            <div class="cui-skeleton__item" style="height: 22px"></div>
          </div>
        </div>

        <div class="cui-skeleton-heading -size--large -spacing--bottom-16 -resolution--desktop">
          <div class="cui-skeleton-heading__content" style="width: 245px">
            <div class="cui-skeleton__item cui-skeleton-heading__title" style="height: 50px"></div>
          </div>
        </div>

        <div class="cui-skeleton-heading -size--large -spacing--bottom-32 -resolution--desktop">
          <div class="cui-skeleton-heading__content" style="width: 820px">
            <div class="cui-skeleton__item cui-skeleton__description"></div>
          </div>
        </div>

        <div class="cui-row -spacing--bottom-8">
          <div class="cui-col-lg-4">
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 95px; height: 13px"></div>
            </div>
          </div>
        </div>

        <div class="cui-row">
          <div class="cui-col-lg-4">
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 282px; height: 50px"></div>
            </div>
          </div>
        </div>

        <div class="cui-row -spacing--top-80">
          <div class="cui-col-lg-12">
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 330px; height: 32px"></div>
            </div>
          </div>
        </div>

        <div class="cui-row -spacing--top-32">
          <div class="cui-col-lg-4">
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 267px"></div>
            </div>
          </div>
          <div class="cui-col-lg-4">
            <div class="cui-skeleton-heading -is--block">
              <div class="cui-skeleton-rectangle -is--block">
                <div class="cui-skeleton__item" style="width: 100%; height: 267px"></div>
              </div>
            </div>
          </div>
          <div class="cui-col-lg-4">
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 267px"></div>
            </div>
          </div>
        </div>

        <div class="cui-row -spacing--top-120">
          <div class="cui-col-lg-4">
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 220px; height: 32px"></div>
            </div>
          </div>
        </div>

        <div class="cui-row -spacing--top-32">
          <div class="cui-col-lg-4 -spacing--bottom-24">
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 156px"></div>
            </div>
          </div>
          <div class="cui-col-lg-4 -spacing--bottom-24">
            <div class="cui-skeleton-heading -is--block">
              <div class="cui-skeleton-rectangle -is--block">
                <div class="cui-skeleton__item" style="width: 100%; height: 156px"></div>
              </div>
            </div>
          </div>
          <div class="cui-col-lg-4 -spacing--bottom-24">
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 156px"></div>
            </div>
          </div>
          <div class="cui-col-lg-4">
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 156px"></div>
            </div>
          </div>
          <div class="cui-col-lg-4">
            <div class="cui-skeleton-heading -is--block">
              <div class="cui-skeleton-rectangle -is--block">
                <div class="cui-skeleton__item" style="width: 100%; height: 156px"></div>
              </div>
            </div>
          </div>
          <div class="cui-col-lg-4">
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 156px"></div>
            </div>
          </div>
        </div>

        <div class="cui-row -spacing--top-120">
          <div class="cui-col-lg-4">
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 120px; height: 32px"></div>
            </div>

            <div class="cui-skeleton-rectangle -spacing--top-32 -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 240px"></div>
            </div>
            <div class="cui-skeleton-rectangle -spacing--top-40 -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 265px"></div>
            </div>
          </div>

          <div class="cui-col-lg-6 col-offset-lg-2">
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 140px; height: 32px"></div>
            </div>

            <div class="cui-skeleton-rectangle -spacing--top-32 -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 130px"></div>
            </div>

            <div class="cui-skeleton-rectangle -spacing--top-32 -is--block">
              <div class="cui-skeleton__item" style="width: 100px; height: 14px"></div>
            </div>
            <div class="cui-skeleton-rectangle -spacing--top-8 -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 48px"></div>
            </div>

            <div class="cui-skeleton-rectangle -spacing--top-24 -is--block">
              <div class="cui-skeleton__item" style="width: 100px; height: 16px"></div>
            </div>
            <div class="cui-skeleton-rectangle -spacing--top-8 -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 48px"></div>
            </div>

            <div class="cui-skeleton-rectangle -spacing--top-24 -is--block">
              <div class="cui-skeleton__item" style="width: 100px; height: 16px"></div>
            </div>
            <div class="cui-skeleton-rectangle -spacing--top-8 -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 48px"></div>
            </div>

            <div class="cui-skeleton-rectangle -spacing--top-24 -is--block">
              <div class="cui-skeleton__item" style="width: 100px; height: 16px"></div>
            </div>
            <div class="cui-skeleton-rectangle -spacing--top-8 -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 48px"></div>
            </div>

            <div class="cui-skeleton-rectangle -spacing--top-24 -is--block">
              <div class="cui-skeleton__item" style="width: 100px; height: 16px"></div>
            </div>
            <div class="cui-skeleton-rectangle -spacing--top-8 -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 48px"></div>
            </div>

            <div class="cui-skeleton-rectangle -spacing--top-24 -is--block">
              <div class="cui-skeleton__item" style="width: 100px; height: 16px"></div>
            </div>
            <div class="cui-skeleton-rectangle -spacing--top-8 -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 48px"></div>
            </div>

            <div class="cui-skeleton-rectangle -spacing--top-32 -is--block">
              <div class="cui-skeleton__item" style="width: 120px; height: 24px"></div>
            </div>

            <div class="cui-skeleton-rectangle -spacing--top-24 -is--block">
              <div class="cui-skeleton__item" style="width: 100px; height: 16px"></div>
            </div>
            <div class="cui-skeleton-rectangle -spacing--top-8 -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 48px"></div>
            </div>

            <div class="cui-skeleton-rectangle -spacing--top-24 -is--block">
              <div class="cui-skeleton__item" style="width: 250px; height: 16px"></div>
            </div>
            <div class="cui-skeleton-rectangle -spacing--top-8 -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 48px"></div>
            </div>

            <div class="cui-skeleton-rectangle -spacing--top-24 -is--block">
              <div class="cui-skeleton__item" style="width: 100px; height: 16px"></div>
            </div>
            <div class="cui-skeleton-rectangle -spacing--top-4 -is--block">
              <div class="cui-skeleton__item" style="width: 240px; height: 13px"></div>
            </div>
            <div class="cui-skeleton-rectangle -spacing--top-8 -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 48px"></div>
            </div>

            <div class="cui-skeleton-rectangle -spacing--top-24 -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 16px"></div>
            </div>
            <div class="cui-skeleton-rectangle -spacing--top-8 -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 142px"></div>
            </div>

            <div class="cui-skeleton-rectangle -spacing--top-40 -is--block" style="display: flex; justify-content: flex-end;">
              <div class="cui-skeleton__item" style="width: 160px; height: 48px"></div>
            </div>
          </div>
        </div>

        <div class="cui-row -spacing--top-120">
          <div class="cui-col-lg-4">
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 220px; height: 32px"></div>
            </div>
          </div>
        </div>

        <div class="cui-row -spacing--top-32 -spacing--bottom-160">
          <div class="cui-col-lg-4">
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 277px"></div>
            </div>
          </div>
          <div class="cui-col-lg-4">
            <div class="cui-skeleton-heading -is--block">
              <div class="cui-skeleton-rectangle -is--block">
                <div class="cui-skeleton__item" style="width: 100%; height: 277px"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>`,
  mobile: `
 <div class="cui cui-grid">
  <div class="cui-container display-lg-none">
    <div class="cui-row">
      <div class="cui-col-lg-12">
        <div class="cui-skeleton-paragraph -spacing--bottom-24 -spacing--top-12">
          <div class="cui-skeleton-paragraph__content" style="width: 100px">
            <div class="cui-skeleton__item" style="height: 22px"></div>
          </div>
        </div>

        <div class="cui-skeleton-heading -size--large -spacing--bottom-16 -spacing--top-32">
          <div class="cui-skeleton-heading__content" style="width: 200px">
            <div class="cui-skeleton__item cui-skeleton-heading__title" style="height: 40px"></div>
          </div>
        </div>

        <div class="cui-row -spacing--bottom-24">
          <div class="cui-col-lg-4">
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="height: 50px"></div>
            </div>
          </div>
        </div>

        <div class="cui-row -spacing--bottom-8">
          <div class="cui-col-lg-4">
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 95px; height: 13px"></div>
            </div>
          </div>
        </div>

        <div class="cui-row">
          <div class="cui-col-lg-4">
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="height: 50px"></div>
            </div>
          </div>
        </div>

        <div class="cui-row -spacing--top-80">
          <div class="cui-col-lg-12">
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 330px; height: 25px"></div>
            </div>
          </div>
        </div>

        <div class="cui-row -spacing--top-32">
          <div class="cui-col-lg-4">
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 270px"></div>
            </div>
          </div>
          <div class="cui-col-lg-4 -spacing--top-16">
            <div class="cui-skeleton-heading -is--block">
              <div class="cui-skeleton-rectangle -is--block">
                <div class="cui-skeleton__item" style="width: 100%; height: 235px"></div>
              </div>
            </div>
          </div>
          <div class="cui-col-lg-4 -spacing--top-16">
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 195px"></div>
            </div>
          </div>
        </div>

        <div class="cui-row -spacing--top-120">
          <div class="cui-col-lg-4">
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 200px; height: 25px"></div>
            </div>
          </div>
        </div>

        <div class="cui-row -spacing--top-32">
          <div class="cui-col-lg-4 -spacing--bottom-24">
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 67px"></div>
            </div>
          </div>
          <div class="cui-col-lg-4 -spacing--bottom-24">
            <div class="cui-skeleton-heading -is--block">
              <div class="cui-skeleton-rectangle -is--block">
                <div class="cui-skeleton__item" style="width: 100%; height: 67px"></div>
              </div>
            </div>
          </div>
          <div class="cui-col-lg-4 -spacing--bottom-24">
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 67px"></div>
            </div>
          </div>
          <div class="cui-col-lg-4 -spacing--bottom-24">
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 67px"></div>
            </div>
          </div>
          <div class="cui-col-lg-4 -spacing--bottom-24">
            <div class="cui-skeleton-heading -is--block">
              <div class="cui-skeleton-rectangle -is--block">
                <div class="cui-skeleton__item" style="width: 100%; height: 67px"></div>
              </div>
            </div>
          </div>
          <div class="cui-col-lg-4 -spacing--bottom-24">
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 67px"></div>
            </div>
          </div>
        </div>

        <div class="cui-row -spacing--top-12">
          <div class="cui-col-lg-4">
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 120px; height: 32px"></div>
            </div>

            <div class="cui-skeleton-rectangle -spacing--top-24 -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 205px"></div>
            </div>
            <div class="cui-skeleton-rectangle -spacing--top-16 -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 215px"></div>
            </div>
          </div>

          <div class="cui-col-lg-6 col-offset-lg-2 -spacing--top-40">
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 140px; height: 32px"></div>
            </div>

            <div class="cui-skeleton-rectangle -spacing--top-24 -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 105px"></div>
            </div>

            <div class="cui-skeleton-rectangle -spacing--top-32 -is--block">
              <div class="cui-skeleton__item" style="width: 100px; height: 14px"></div>
            </div>
            <div class="cui-skeleton-rectangle -spacing--top-8 -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 48px"></div>
            </div>

            <div class="cui-skeleton-rectangle -spacing--top-16 -is--block">
              <div class="cui-skeleton__item" style="width: 100px; height: 16px"></div>
            </div>
            <div class="cui-skeleton-rectangle -spacing--top-8 -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 48px"></div>
            </div>

            <div class="cui-skeleton-rectangle -spacing--top-16 -is--block">
              <div class="cui-skeleton__item" style="width: 100px; height: 16px"></div>
            </div>
            <div class="cui-skeleton-rectangle -spacing--top-8 -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 48px"></div>
            </div>

            <div class="cui-skeleton-rectangle -spacing--top-16 -is--block">
              <div class="cui-skeleton__item" style="width: 100px; height: 16px"></div>
            </div>
            <div class="cui-skeleton-rectangle -spacing--top-8 -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 48px"></div>
            </div>

            <div class="cui-skeleton-rectangle -spacing--top-16 -is--block">
              <div class="cui-skeleton__item" style="width: 100px; height: 16px"></div>
            </div>
            <div class="cui-skeleton-rectangle -spacing--top-8 -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 48px"></div>
            </div>

            <div class="cui-skeleton-rectangle -spacing--top-16 -is--block">
              <div class="cui-skeleton__item" style="width: 100px; height: 16px"></div>
            </div>
            <div class="cui-skeleton-rectangle -spacing--top-8 -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 48px"></div>
            </div>

            <div class="cui-skeleton-rectangle -spacing--top-24 -is--block">
              <div class="cui-skeleton__item" style="width: 120px; height: 24px"></div>
            </div>

            <div class="cui-skeleton-rectangle -spacing--top-24 -is--block">
              <div class="cui-skeleton__item" style="width: 100px; height: 16px"></div>
            </div>
            <div class="cui-skeleton-rectangle -spacing--top-8 -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 48px"></div>
            </div>

            <div class="cui-skeleton-rectangle -spacing--top-16 -is--block">
              <div class="cui-skeleton__item" style="width: 130px; height: 16px"></div>
            </div>
            <div class="cui-skeleton-rectangle -spacing--top-8 -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 48px"></div>
            </div>

            <div class="cui-skeleton-rectangle -spacing--top-16 -is--block">
              <div class="cui-skeleton__item" style="width: 100px; height: 16px"></div>
            </div>
            <div class="cui-skeleton-rectangle -spacing--top-4 -is--block">
              <div class="cui-skeleton__item" style="width: 240px; height: 13px"></div>
            </div>
            <div class="cui-skeleton-rectangle -spacing--top-8 -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 48px"></div>
            </div>

            <div class="cui-skeleton-rectangle -spacing--top-16 -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 16px"></div>
            </div>
            <div class="cui-skeleton-rectangle -spacing--top-8 -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 142px"></div>
            </div>

            <div class="cui-skeleton-rectangle -spacing--top-24 -is--block" style="display: flex; justify-content: flex-end;">
              <div class="cui-skeleton__item" style="width: 105px; height: 48px"></div>
            </div>
          </div>
        </div>

        <div class="cui-row -spacing--top-40">
          <div class="cui-col-lg-4">
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 220px; height: 25px"></div>
            </div>
          </div>
        </div>

        <div class="cui-row -spacing--top-40 -spacing--bottom-160">
          <div class="cui-col-lg-4">
            <div class="cui-skeleton-rectangle -is--block">
              <div class="cui-skeleton__item" style="width: 100%; height: 210px"></div>
            </div>
          </div>
          <div class="cui-col-lg-4 -spacing--top-48 -spacing--bottom-48">
            <div class="cui-skeleton-heading -is--block">
              <div class="cui-skeleton-rectangle -is--block">
                <div class="cui-skeleton__item" style="width: 100%; height: 210px"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`
};
